// extracted by mini-css-extract-plugin
export default {"dekanatCard":"DekanatKartice_dekanatCard__Qz+Bt","dekanatPosition":"DekanatKartice_dekanatPosition__3dax3"};